exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".app,html{height:100%}.ng-cloak{display:none}.app{background:#f7f9fa;background:var(--ring-sidebar-background-color);margin:0;padding:0;line-height:20px;color:#1f2326;color:var(--ring-text-color);font-size:13px;font-size:var(--ring-font-size);font-family:system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Droid Sans,Helvetica Neue,Arial,sans-serif;font-family:var(--ring-font-family)}.app_white{background:#fff;background:var(--ring-content-background-color)}.app__container{min-height:calc(100% - 32px);padding-top:32px;margin-bottom:-121px;text-align:center}.app__container:after{content:\"\";display:block;height:121px}.app__content{display:inline-block;text-align:left;width:640px}.app__footer{height:81px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/src?{}!./node_modules/sass-loader/lib/loader.js?sourcemap&outputStyle=expanded!./src/blocks/app/app.scss
// module id = 522
// module chunks = 0